import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Dropdown } from '@lwt-helix/dropdown';
import Modal from '@lwt-helix/modal';
import { Button } from '@lwt-helix/buttons';
import { GetBulkActionProps } from './BulkActionButtonProps';
import { bulkApproveInvitation, bulkReinviteUsers } from '../../../../api/AuthenticationApi';
import { UserInvitationStatus, InvitationStatusText } from '../../../../constants/Enums';

const BulkActions = ({ selectedRows, isBulkApproveDisabled, isBulkActionsDisabled }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [bulkAction, setBulkAction] = useState(null);
    const toggleModalStatus = () => {
        setIsModalOpen(!isModalOpen)
    };
    const dispatch = useDispatch();

    const allSelectedRowsPendingApproval = selectedRows.every(
        row => row.status === UserInvitationStatus.PENDINGAPPROVAL
    );
    const allSelectedRowsInvited = selectedRows.every(row => row.status === UserInvitationStatus.INVITED);

    const bulkActionSelectionHandler = (action) => {
        setBulkAction(action);
        toggleModalStatus();
    };

    const bulkActionHandler = (selectedRows) => {
        if (bulkAction === InvitationStatusText.APPROVE) {
            const pendingApprovalArr = selectedRows.filter(s => {
                return s.status?.toUpperCase() === UserInvitationStatus.PENDINGAPPROVAL;
            });
            const invitationIds = pendingApprovalArr.map(e => {
                return { id: e.id }
            });
            invitationIds.length && dispatch(bulkApproveInvitation(invitationIds));
        } else if (bulkAction === InvitationStatusText.REINVITE) {
            const invitedArr = selectedRows.filter(s => {
                return s.status?.toUpperCase() === UserInvitationStatus.INVITED;
            });
            const invitationIds = invitedArr.map(e => {
                return { id: e.id }
            });
            invitationIds.length && dispatch(bulkReinviteUsers(invitationIds));
        }
        toggleModalStatus();
    };

    const BulkActionProps = GetBulkActionProps(
        bulkActionSelectionHandler,
        isBulkApproveDisabled || !allSelectedRowsPendingApproval,
        !allSelectedRowsInvited,
        isBulkActionsDisabled || (!allSelectedRowsPendingApproval && !allSelectedRowsInvited),
        selectedRows
    );

    const modalButtons = (
        <>
            <Button
                color={'primary'}
                onClick={() => {
                    bulkActionHandler(selectedRows)
                }} className={'mr-2'}
                dataLwtId={`bulk-action-${bulkAction}-button`}
            >
                {bulkAction}
            </Button>
            <Button
                color={'secondary'}
                outline={true}
                onClick={() => {
                    toggleModalStatus()
                }} className={'mr-2'}
                dataLwtId={'bulk-action-modal-close-button'}
            >
                Cancel
            </Button>
        </>
    );

    const bulkActionsModal = isModalOpen
        ? (
            <Modal
                show={isModalOpen}
                closeModal={() => {
                    toggleModalStatus()
                }}
                size={'lg'}
                dataLwtId={'bulk-actions-modal'}
                title={`${bulkAction} the selected users?`}
                showFooter={false}
            >
                {modalButtons}
            </Modal>
        )
        : null;

    return (
        <>
            <Dropdown
                dataLwtId={'bulk-actions-dropdown-button'}
                toggleProps={BulkActionProps.toggleProps}
                items={BulkActionProps.items}
                menuProps={BulkActionProps.menuProps}
                className={'mr-2'}
            />
            {bulkActionsModal}
        </>
    );
};

BulkActions.propTypes = {
    selectedRows: PropTypes.array,
    isBulkApproveDisabled: PropTypes.bool,
    isBulkActionsDisabled: PropTypes.bool
};

export default BulkActions;